module.exports = __webpack_public_path__ + "static/media/assembly.d388ee39.svg";